import { Component, OnInit, Inject, Input } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import {Observable} from "rxjs";

@Component({
  selector: 'app-transaction-detail-dialog.component',
  templateUrl: './transaction-detail-dialog.component.html',
  styleUrls: ['./transaction-detail-dialog.component.css']
})
export class TransactionDetailDialogComponent implements OnInit {

  transaction: any;

  constructor(
    public dialogRef: MdDialogRef<TransactionDetailDialogComponent>,
    @Inject(MD_DIALOG_DATA) public data: any
  ) {
    this.transaction = data.transaction;
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/transaction-detail-dialog/transaction-detail-dialog.component.ts